import script from "./AsistenteVirtual.vue?vue&type=script&setup=true&lang=js"
export * from "./AsistenteVirtual.vue?vue&type=script&setup=true&lang=js"

import "./AsistenteVirtual.vue?vue&type=style&index=0&id=d5bbfa88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5bbfa88"]])

export default __exports__